import React, { useEffect } from "react";
import { Tooltip } from "@material-ui/core";
import ShareButton from "./ShareButton";
import EndGameSummaryTable from "./EndGameSummaryTable";
import "../../styling/messages.css";

const MessageOverlay = ({
  snackbars = [],
  handleSnackbarClose,
}) => {

  // Format message to support new lines
  const formatMessage = (message) => {
    if (!message) return null;
    
    // Split by newlines and render each line
    const lines = message.split('\n');
    
    return (
      <div className="message-text">
        {lines.map((line, index) => (
          <div key={index} className="message-line">
            {line}
          </div>
        ))}
      </div>
    );
  };

  // Handle escape key press - closes the oldest message
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && snackbars.length > 0) {
        // Close the first snackbar (oldest)
        const oldestSnackbar = snackbars[0];
        handleSnackbarClose(oldestSnackbar.id);
      }
    };

    if (snackbars.length > 0) {
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [snackbars, handleSnackbarClose]);

  return (
    <>
      {/* Clickable blurred overlay while any snackbar is open */}
      {snackbars.length > 0 && (
        <div 
          className="message-overlay" 
          onClick={() => {
            // Close the oldest (first) message when clicking overlay
            const oldestSnackbar = snackbars[0];
            handleSnackbarClose(oldestSnackbar.id);
          }}
        />
      )}

      {/* Container for stacked snackbars */}
      <div className="message-container">
        {[...snackbars].reverse().map((snackbar) => (
          <div 
            key={snackbar.id} 
            className="message-wrapper fading-in"
          >
            <div className="message-card">
              {/* Close button */}
              <Tooltip title="Close (Esc)" arrow placement="left">
                <button
                  className="message-close-button"
                  onClick={() => handleSnackbarClose(snackbar.id)}
                  aria-label="Close message"
                >
                  ✕
                </button>
              </Tooltip>
              
              {/* Message content */}
              {formatMessage(snackbar.message)}

              {/* End game summary table */}
              {snackbar.endGameSummary && Array.isArray(snackbar.endGameSummary) && snackbar.endGameSummary.length > 0 && (
                <div className="message-endgame-section" onClick={(e) => e.stopPropagation()}>
                  <EndGameSummaryTable rows={snackbar.endGameSummary} />
                </div>
              )}
              
              {/* Share button for messages with showShare enabled */}
              {snackbar.showShare && snackbar.shareText && (
                <div 
                  className="message-share-section"
                  onClick={(e) => e.stopPropagation()}
                >
                  <ShareButton 
                    text={snackbar.message}
                    shareText={snackbar.shareText}
                    variant="default"
                  />
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default MessageOverlay;